// extracted by mini-css-extract-plugin
module.exports = {"businessbg":"business_businessbg__3ye6j","businessStyle":"business_businessStyle__1BdZh","Businessnews":"business_Businessnews__1QnXR","underline":"business_underline__3WNJJ"};